import React from 'react'

import { Group } from '../../models/Group'
import { useGroups } from '../../state/entities'
import Slugs from './Slugs/Slugs'
import GroupSlug from './GroupSlug/GroupSlug'

const render = (group: Group) => <GroupSlug key={group.uuid} group={group} />

export default React.memo(function GroupSlugs({
  uuids,
  max,
  className,
}: {
  uuids: string[]
  max: number
  className?: string
}) {
  const { groups } = useGroups(uuids.slice(0, max))
  return <Slugs items={groups} max={max} total={uuids.length} render={render} className={className} />
})
